export const TIKTOK_ACCOUNT_ACTION_STEP = {
  CONNECT_OR_CREATE: "connectOrCreate",
  CREATE_AD_ACCOUNT: "createAdAccount",
};
